/* eslint-disable react/display-name */
/* eslint-disable no-prototype-builtins */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Moment from 'moment';
import { toast } from 'react-toastify';
import { diffWordsWithSpace } from 'diff';
import {
    isEqual as _isEqual,
    get as _get,
    has as _has,
} from 'lodash';

import { makeStyles, useTheme } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Select from '@mui/material/Select';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import MenuItem from '@mui/material/MenuItem';

import SuricataService from '../../../../data/suricata-service';
import Auth from '../../../../data/auth-service';

import Animations from '../../../../libraries/animations';

const useStyles = makeStyles(theme => ({
    tabBar: {
        marginTop: theme.spacing(3),
    },
    ruleDataBox: {
        border: `1px solid ${theme.palette.primary.main}`,
        background: theme.styled.paper.background,
        color: theme.palette.text.primary,
        padding: theme.spacing(1),
        minWidth: '300px',
        wordWrap: 'break-word',
    },
    ruleVersionSelect: {
        minWidth: '200px',
    },
    filterButtons: {
        '& button': {
            padding: '2px 5px',
            fontSize: '11px',
        }
    },
    otherPolicies: {
        fontSize: '18px',
    },
    ...Animations.Push(theme),
}));

const Rule = ({
    ruleID,
    globalMod,
    updateMod,
    updateMode,
    updater,
    updateUpdater,
}) => {
    const classes = useStyles();
    const theme = useTheme();
    const params = useParams();
    const [tab, setTab] = useState(0);

    const suriPerms = Auth.permissions.get('SuricataRulesPolicy');
    const [readonly] = useState(!suriPerms.write);
    const [rule, setRule] = useState({});
    const [otherPolicies, setOtherPolicies] = useState([]);
    const [otherPolicyMods, setOtherPolicyMods] = useState([]);
    const [ruleHistory, setRuleHistory] = useState([]);
    const [mod, setMod] = useState({ actions: {}, source: 'ui', stack: [] });
    const [selectedVersion, setSelectedVersion] = useState('');
    const [changes, setChanges] = useState(false);

    useEffect(() => {
        if (ruleID && params.policy) {
            getRule();
            getRuleFromAllPolicies();
            getRuleVersionHistory();

            SuricataService.getRuleFromAllPolicies(ruleID).then(res => {
                setOtherPolicies(res);
                setOtherPolicyMods(res.map(() => {
                    return {
                        actions: {},
                        source: 'ui',
                        stack: []
                    };
                }));
            });
            SuricataService.getRuleVersionHistory(ruleID).then(res => {
                setRuleHistory(res);
                if (res.length) {
                    setSelectedVersion(res[0].ver);
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ruleID]);

    useEffect(() => {
        setChanges(mod.actions.hasOwnProperty(ruleID));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mod]);

    useEffect(() => {
        if (globalMod && globalMod.actions.hasOwnProperty(ruleID)) {
            setMod({
                ...mod,
                actions: { [ruleID]: globalMod.actions[ruleID] }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [globalMod]);

    const getRule = () => {
        SuricataService.getPolicyRuleDetails(params.policy, ruleID).then(res => {
            setRule(res);
        }, err => {
            console.error('Error getting rule details ::: ', err);
        });
    };

    const getRuleFromAllPolicies = () => {
        SuricataService.getRuleFromAllPolicies(ruleID).then(res => {
            setOtherPolicies(res);
            setOtherPolicyMods(res.map(() => {
                return { actions: {}, source: 'ui', stack: [] };
            }));
        });
    };

    const getRuleVersionHistory = () => {
        SuricataService.getRuleVersionHistory(ruleID).then(res => {
            setRuleHistory(res);
            if (res.length) {
                setSelectedVersion(res[0].ver);
            }
        });
    };

    const handleUndo = () => {
        setMod({ actions: {}, source: 'ui', stack: [], });
        if (globalMod && globalMod.actions.hasOwnProperty(ruleID)) {
            const g = { ...globalMod };
            delete g.actions[ruleID];
            updateMod(g);
        }
    };

    const handleDone = () => {
        // updateMod({
        //     ...globalMod,
        //     actions: {
        //         ...globalMod.actions,
        //         ...mod.actions,
        //     }
        // });
        updateMode('suricata');
    };

    const handleTabChange = (e, t) => {
        setTab(t);
    };

    const handleUpdateSelectedVersion = (e) => {
        setSelectedVersion(e.target.value);
    };

    const handleUpdateRuleAction = (id, action) => {
        const u = { ...updater };

        if (_has(u.rules, id, null)) {
            if (u.rules[id].action === action) {
                delete u.rules[id].action;
            } else {
                u.rules[id].action = action;
            }
        } else {
            u.rules[id] = { action: action };
        }

        updateUpdater(u);
    };

    const handleUpdateOtherRulesRule = (v, i) => {
        const o = [...otherPolicyMods];
        const stackIdx = o[i].stack.findIndex(s => s.hasOwnProperty('r'));

        if (stackIdx !== -1) {
            o[i].stack.splice(stackIdx, 1);
        } else {
            o[i].stack.push({
                r: {
                    [v.id]: !v.enabled
                }
            });
        }

        setOtherPolicyMods(o);
    };

    const handleUpdateOtherRulesGroup = (v, i) => {
        const o = [...otherPolicyMods];
        const stackIdx = o[i].stack.findIndex(s => s.hasOwnProperty('g'));

        if (stackIdx !== -1) {
            o[i].stack.splice(stackIdx, 1);
        } else {
            o[i].stack.push({
                g: {
                    [v.group]: !v.group_enabled
                }
            });
        }

        setOtherPolicyMods(o);
    };

    const handleUpdateOtherRulesAction = (e, v, i) => {
        const o = [...otherPolicyMods];

        if (o[i].actions.hasOwnProperty(v.id) && v.action === e.target.value) {
            delete o[i].actions[v.id];
        } else {
            o[i].actions[v.id] = { action: e.target.value };
        }

        setOtherPolicyMods(o);
    };

    const checkOtherRuleChange = (i) => {
        return _isEqual(otherPolicyMods[i], { actions: {}, source: 'ui', stack: [] });
    };

    const handleOtherRulesUndo = (v, i) => {
        const o = [...otherPolicyMods];
        o[i] = { actions: {}, source: 'ui', stack: [] };
        setOtherPolicyMods(o);
    };

    const handleOtherRulesPush = (v, i) => {
        SuricataService.updatePolicy(v.policy, v.policy_type, otherPolicyMods[i]).then(() => {
            toast.success('Other Suricata policy pushed successfully');
            getRule();
            getRuleFromAllPolicies();
        }, err => {
            console.error(err);
            toast.error('Failed to update other Suricata policy...');
        });
    };

    return (
        <Grid container>
            <Grid item xs={12}>
                <Box display="flex" justifyContent="flex-end">
                    <Box ml={2}>
                        <Button
                            disabled={!changes}
                            variant="contained"
                            color="secondary"
                            onClick={handleUndo}
                        >
                            Undo
                        </Button>
                    </Box>
                    <Box ml={2}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleDone}
                        >
                            { changes ? 'Done' : 'Back' }
                        </Button>
                    </Box>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Paper elevation={3}>
                    <Box>
                        <AppBar position="static" className={classes.tabBar}>
                            <Tabs value={tab} onChange={handleTabChange}>
                                <Tab value={0} aria-label="rule details" label="Rule Details" />
                                <Tab value={1} aria-label="other policies" label="Other Policies" />
                            </Tabs>
                        </AppBar>
                        <Box p={1} mt={1}>
                            <Box value={tab} index={0} hidden={tab !== 0}>
                                <Grid container spacing={5}>
                                    <Grid item xs={4}>
                                        <Box mb={2} display="flex" justifyContent="space-between" minWidth={'100%'}>
                                            <Box>Group:</Box>
                                            <Box>{_get(rule, 'group', '')}</Box>
                                        </Box>
                                        <Box mb={2} display="flex" justifyContent="space-between" minWidth={'100%'}>
                                            <Box>ID:</Box>
                                            <Box>{rule && rule.id}</Box>
                                        </Box>
                                        <Box mb={2} display="flex" justifyContent="space-between" minWidth={'100%'}>
                                            <Box>Version:</Box>
                                            <Box>{rule && rule.ver}</Box>
                                        </Box>
                                        <Box my={2} display="flex" justifyContent="space-between" minWidth={'100%'}>
                                            <Box>Status:</Box>
                                            <Box>{rule && rule.enabled != null ? rule.enabled ? 'Enabled' : 'Disabled' : ''}</Box>
                                        </Box>
                                        <Box mb={2} display="flex" justifyContent="space-between" minWidth={'100%'}>
                                            <Box>Purge:</Box>
                                            <Box>{rule && rule.keep != null ? rule.keep || (rule.auto !== true) ? 'Rule will be kept' : 'Rule will be purged' : ''}</Box>
                                        </Box>
                                        <Box mb={2} display="flex" justifyContent="space-between" minWidth={'100%'}>
                                            <Box>Last Seen:</Box>
                                            <Box>
                                                {Moment(rule.last_seen).format(theme.date.longtz)}
                                            </Box>
                                        </Box>
                                        <Box mb={2} display="flex" justifyContent="space-between" minWidth={'100%'}>
                                            <Box>Action:</Box>
                                            <Box>
                                                <ButtonGroup disabled={readonly} className={classes.filterButtons}>
                                                    <Button
                                                        color="secondary"
                                                        variant={(() => {
                                                            const m = _get(updater, `rules[${rule.id}].action`, rule.action);
                                                            return m === 'pass' ? 'contained' : 'outlined';
                                                        })()}
                                                        aria-label="pass action"
                                                        onClick={() => { handleUpdateRuleAction(rule.id, 'pass') }}
                                                    >Pass</Button>
                                                    <Button
                                                        color="secondary"
                                                        variant={(() => {
                                                            const m = _get(updater, `rules[${rule.id}].action`, rule.action);
                                                            return m === 'drop' ? 'contained' : 'outlined';
                                                        })()}
                                                        aria-label="drop action"
                                                        onClick={() => { handleUpdateRuleAction(rule.id, 'drop') }}
                                                    >Drop</Button>
                                                    <Button
                                                        color="secondary"
                                                        variant={(() => {
                                                            const m = _get(updater, `rules[${rule.id}].action`, rule.action);
                                                            return m === 'alert' ? 'contained' : 'outlined';
                                                        })()}
                                                        aria-label="alert action"
                                                        onClick={() => { handleUpdateRuleAction(rule.id, 'alert') }}
                                                    >Alert</Button>
                                                </ButtonGroup>
                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <Box mb={2} display="flex" justifyContent="space-between" minWidth={'100%'}>
                                            <Box>Compare with previous values</Box>
                                            <Box>
                                                <Select className={classes.ruleVersionSelect} value={selectedVersion} onChange={handleUpdateSelectedVersion}>
                                                    {ruleHistory.map((v, i) => {
                                                        return (
                                                            <MenuItem key={'rule-history-' + i} value={v.ver}>{v.ver}</MenuItem>
                                                        );
                                                    })}
                                                    {!ruleHistory.length && <MenuItem></MenuItem>}
                                                </Select>
                                            </Box>
                                        </Box>
                                        <Box mb={2} minWidth={'100%'}>
                                            <Box pr={2}>Message</Box>
                                            <Box className={classes.ruleDataBox}>
                                                <code>{rule && rule.name}</code>
                                            </Box>
                                        </Box>
                                        <Box mb={2} minWidth={'100%'}>
                                            <Box pr={2}>Header</Box>
                                            <Box className={classes.ruleDataBox}>
                                                <Box display={rule.name === (ruleHistory.length && ruleHistory[0].name) ? 'block' : 'none'}>
                                                    {(() => {
                                                        const oldValue = rule.header;
                                                        const newValue = (() => {
                                                            if (ruleHistory && ruleHistory.length) {
                                                                const i = ruleHistory.findIndex(v => v.ver === selectedVersion);
                                                                if (i !== -1) {
                                                                    return ruleHistory[i].header;
                                                                }
                                                            }
                                                            return rule.header;
                                                        })();

                                                        if (oldValue && newValue) {
                                                            const diff = diffWordsWithSpace(oldValue, newValue);
                                                            const items = [];

                                                            diff.forEach((part, i) => {
                                                                const color = part.added ? 'green' : part.removed ? 'red' : theme.palette.text.primary;
                                                                items.push(<code key={'diff-header-' + i} style={{ color: color, marginLeft: '2px' }}>
                                                                    {part.value}
                                                                </code>);
                                                            });

                                                            return items;
                                                        }
                                                    })()}
                                                </Box>
                                            </Box>
                                        </Box>
                                        <Box mb={2} minWidth={'100%'}>
                                            <Box pr={2}>Options</Box>
                                            <Box className={classes.ruleDataBox}>
                                                <Box display={rule.name === (ruleHistory.length && ruleHistory[0].name) ? 'block' : 'none'}>
                                                    {(() => {
                                                        const oldValue = rule.options;
                                                        const newValue = (() => {
                                                            if (ruleHistory && ruleHistory.length) {
                                                                const i = ruleHistory.findIndex(v => v.ver === selectedVersion);
                                                                if (i !== -1) {
                                                                    return ruleHistory[i].options;
                                                                }
                                                            }
                                                            return rule.options;
                                                        })();

                                                        if (oldValue && newValue) {
                                                            const diff = diffWordsWithSpace(oldValue, newValue);
                                                            const items = [];

                                                            diff.forEach((part, i) => {
                                                                const color = part.added ? 'green' : part.removed ? 'red' : theme.palette.text.primary;
                                                                items.push(<code key={'diff-option-' + i} style={{ color: color, marginLeft: '2px' }}>
                                                                    {part.value}
                                                                </code>);
                                                            });

                                                            return items;
                                                        }
                                                    })()}
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box value={tab} index={0} hidden={tab !== 1} pt={2}>
                                <Grid container spacing={2}>
                                    <Grid container item xs={12}>
                                        <Grid item xs={4}><Typography className={classes.otherPolicies}>Policy</Typography></Grid>
                                        <Grid item xs={2}><Typography className={classes.otherPolicies}>Rule</Typography></Grid>
                                        <Grid item xs={2}><Typography className={classes.otherPolicies}>Group</Typography></Grid>
                                        <Grid item xs={2}><Typography className={classes.otherPolicies}>Action</Typography></Grid>
                                        <Grid item xs={2}></Grid>
                                    </Grid>
                                    {otherPolicies.map((v, i) => {
                                        return (
                                            <Grid container item xs={12} key={'other-policies-' + i}>
                                                <Grid item xs={4}>
                                                    {v.policy}
                                                </Grid>
                                                <Grid item xs={2} className={classes.filterButtons}>
                                                    <Button
                                                        disabled={readonly || /.mc2$/.test(v.policy)}
                                                        variant="outlined"
                                                        color={(() => {
                                                            if (otherPolicyMods.length) {
                                                                const rIdx = otherPolicyMods[i].stack.findIndex(s => s.hasOwnProperty('r'));
                                                                if (rIdx !== -1) {
                                                                    return otherPolicyMods[i].stack[rIdx].r[v.id] ? 'primary' : 'secondary';
                                                                }
                                                            }
                                                            return v.enabled ? 'primary' : 'secondary';
                                                        })()}
                                                        aria-label="enable or disable rule on other policy"
                                                        onClick={() => { handleUpdateOtherRulesRule(v, i) }}
                                                    >{(() => {
                                                            if (otherPolicyMods.length) {
                                                                const rIdx = otherPolicyMods[i].stack.findIndex(s => s.hasOwnProperty('r'));
                                                                if (rIdx !== -1) {
                                                                    return otherPolicyMods[i].stack[rIdx].r[v.id] ? 'Enabled' : 'Disabled';
                                                                }
                                                            }
                                                            return v.enabled ? 'Enabled' : 'Disabled';
                                                        })()}</Button>
                                                </Grid>
                                                <Grid item xs={2} className={classes.filterButtons}>
                                                    <Button
                                                        disabled={readonly || /.mc2$/.test(v.policy)}
                                                        variant="outlined"
                                                        color={(() => {
                                                            if (otherPolicyMods.length) {
                                                                const gIdx = otherPolicyMods[i].stack.findIndex(s => s.hasOwnProperty('g'));
                                                                if (gIdx !== -1) {
                                                                    return otherPolicyMods[i].stack[gIdx].g[v.group] ? 'primary' : 'secondary';
                                                                }
                                                            }
                                                            return v.group_enabled ? 'primary' : 'secondary';
                                                        })()}
                                                        aria-label="enable or disable group on other policy"
                                                        onClick={() => { handleUpdateOtherRulesGroup(v, i) }}
                                                    >{(() => {
                                                            if (otherPolicyMods.length) {
                                                                const gIdx = otherPolicyMods[i].stack.findIndex(s => s.hasOwnProperty('g'));
                                                                if (gIdx !== -1) {
                                                                    return otherPolicyMods[i].stack[gIdx].g[v.group] ? 'Enabled' : 'Disabled';
                                                                }
                                                            }
                                                            return v.group_enabled ? 'Enabled' : 'Disabled';
                                                        })()}</Button>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Select
                                                        disabled={readonly || /.mc2$/.test(v.policy)}
                                                        value={(() => {
                                                            if (otherPolicyMods.length) {
                                                                return otherPolicyMods[i].actions.hasOwnProperty(v.id) ? otherPolicyMods[i].actions[v.id].action : v.action;
                                                            }
                                                            return v.action;
                                                        })()}
                                                        variant='standard'
                                                        onChange={(e) => { handleUpdateOtherRulesAction(e, v, i) }}>
                                                        <MenuItem value="alert">Alert</MenuItem>
                                                        <MenuItem value="pass">Pass</MenuItem>
                                                        <MenuItem value="drop">Drop</MenuItem>
                                                    </Select>
                                                </Grid>
                                                {!readonly && <Grid container item xs={2}>
                                                    <Box ml={2}><Button
                                                        disabled={/.mc2$/.test(v.policy) || checkOtherRuleChange(i)}
                                                        variant="contained"
                                                        color="secondary"
                                                        aria-label="undo other policy changes"
                                                        onClick={() => { handleOtherRulesUndo(v, i) }}
                                                    >
                                                        Undo
                                                    </Button></Box>
                                                    <Box ml={2}><Button
                                                        disabled={/.mc2$/.test(v.policy) || checkOtherRuleChange(i)}
                                                        variant="contained"
                                                        color="primary"
                                                        aria-label="push to other policy"
                                                        onClick={() => { handleOtherRulesPush(v, i) }}
                                                    >Push</Button></Box>
                                                </Grid>}
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                            </Box>
                        </Box>
                    </Box>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default Rule;
